import * as actions from './employee/actions'
import * as mutations from './employee/mutations'
import * as getters from './employee/getters'

import { dataProps } from './employee/properties'

const state = {
    list: [],
    nav: {
        page_number: 1, had_results: false,
        limit: 10,
        total: 0,
        sort_column_name: 'staff_name',
        sort_direction: 0, search_term: '', 
        search_term_array: []
    },
    allocated_production_stage: [],
    props: JSON.parse(JSON.stringify(dataProps)),
    statement: {
        date_range: ['', ''],
        list: []
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/employee.js